import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
export function PainSection() {
  return <section className="bg-white py-12 px-4 text-[#111827]" data-id="element-110">
      <div className="max-w-3xl mx-auto text-center space-y-8" data-id="element-111">
        <p className="text-xl md:text-2xl font-semibold" data-id="element-112">
          Mientras pensás que nunca va a pasar… el día llega.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-lg font-medium text-[#4B5563]" data-id="element-113">
          <div className="flex items-center justify-center gap-2 p-3 bg-red-50 rounded-lg" data-id="element-114">
            <AlertTriangleIcon className="w-5 h-5 text-red-500" data-id="element-115" />
            <span data-id="element-116">Una convulsión inesperada.</span>
          </div>
          <div className="flex items-center justify-center gap-2 p-3 bg-red-50 rounded-lg" data-id="element-117">
            <AlertTriangleIcon className="w-5 h-5 text-red-500" data-id="element-118" />
            <span data-id="element-119">Un atragantamiento.</span>
          </div>
          <div className="flex items-center justify-center gap-2 p-3 bg-red-50 rounded-lg" data-id="element-120">
            <AlertTriangleIcon className="w-5 h-5 text-red-500" data-id="element-121" />
            <span data-id="element-122">Una intoxicación.</span>
          </div>
          <div className="flex items-center justify-center gap-2 p-3 bg-red-50 rounded-lg" data-id="element-123">
            <AlertTriangleIcon className="w-5 h-5 text-red-500" data-id="element-124" />
            <span data-id="element-125">Una hemorragia.</span>
          </div>
        </div>

        <div className="space-y-6 pt-4" data-id="element-126">
          <p className="text-xl font-bold" data-id="element-127">
            El problema no es solo la emergencia. Es el pánico.
          </p>

          <p className="text-lg text-[#4B5563]" data-id="element-128">
            Buscás información. Dudás si es grave. Intentás ayudar sin estar
            seguro. El tiempo pasa.
          </p>

          <p className="text-xl font-bold text-red-600" data-id="element-129">
            No es falta de amor. Es falta de preparación.
          </p>

          <p className="text-2xl font-bold pt-4" data-id="element-130">
            Por eso creamos el Manual de Emergencias para Mascotas.
          </p>
        </div>
      </div>
    </section>;
}